import { useState } from "react";
import USBMenu from "@usb-shield/react-menu";
import engflag from "../assets/eng.svg";
import { LANGUAGE_TYPES } from "../constants";

const DropdownMenu = () => {
  const [language, setLanguage] = useState("English");

  return (
    <div className="d-flex align-center">
      <img
        data-src={engflag}
        alt="flag"
        ref={(img) => {
          if (img) img.src = engflag;
        }}
        className="m-2"
        width="26"
        height="16"
      />
      <USBMenu>
        <USBMenu.Trigger className="menu-trigger">
          {language}
          <USBMenu.TriggerIcon />
        </USBMenu.Trigger>
        <USBMenu.Content
          position={"bottom"}
          align={"center"}
          aria-label="Language actions"
          role="menu"
        >
          {LANGUAGE_TYPES.map((item) => (
            <USBMenu.Item
              key={item.key}
              className="menu-content"
              onSelect={() => {
                setLanguage(item.value);
              }}
            >
              {item.value}
            </USBMenu.Item>
          ))}
        </USBMenu.Content>
      </USBMenu>
    </div>
  );
};

export default DropdownMenu;
